module.exports = __webpack_public_path__ + "img/title.df9ddb07.png";